<template>
  <v-flex xs12 sm12 md12 lg8 xl8 data-qa="loanrepaymentsummary-flex-lnik5a">
    <v-card data-qa="loanrepaymentsummary-card-zv7wyd">
      <v-card-title class="headline mx-6" data-qa="loanrepaymentsummary-card-title-zl2hqk">
        {{ $t("loanRepaymentSummary.summary") }}
      </v-card-title>
      <v-flex data-qa="loanrepaymentsummary-flex-his58f">
        <v-row class="px-4 pb-4" data-qa="loanrepaymentsummary-row-bfschi">
          <v-flex class="text-left mx-10" xs12 sm12 md12 lg12 xl12 data-qa="loanrepaymentsummary-flex-nh0hqh">
            <v-layout class="py-2" row wrap data-qa="loanrepaymentsummary-layout-ysepi">
              <v-flex xs6 sm6 md6 lg6 xl6 data-qa="loanrepaymentsummary-flex-kym87m">
                <span class="overline font-weight-bold text-uppercase" data-qa="loanrepaymentsummary-span-avakce">
                  {{ $t("loanRepaymentSummary.loanAccount") }}
                </span>
                <br data-qa="loanrepaymentsummary-br-wdtsc8"  />
                {{ config.payload.toAcc }}
              </v-flex>
              <v-flex xs6 sm6 md6 lg6 xl6 data-qa="loanrepaymentsummary-flex-vwrk9d">
                <span class="overline font-weight-bold text-uppercase" data-qa="loanrepaymentsummary-span-r3v05h">
                  {{ $t("loanRepaymentSummary.amount") }}
                </span>
                <br data-qa="loanrepaymentsummary-br-il7ag"  />
                {{ $formatter.currency.format(config.payload.transferAmount, config.payload.currency) }}
              </v-flex>
            </v-layout>
            <v-layout class="py-2" row wrap data-qa="loanrepaymentsummary-layout-7ebpjc">
              <v-flex xs6 sm6 md6 lg6 xl6 data-qa="loanrepaymentsummary-flex-z5o18">
                <span class="overline font-weight-bold text-uppercase" data-qa="loanrepaymentsummary-span-buydzm">
                  {{ $t("loanRepaymentSummary.fromAccount") }}
                </span>
                <br data-qa="loanrepaymentsummary-br-jlbsol"  />
                {{ config.payload.fromAcc }}
              </v-flex>
              <v-flex v-if="config.payload.charges" xs6 sm6 md6 lg6 xl6 data-qa="loanrepaymentsummary-flex-29dqk">
                <span class="overline font-weight-bold text-uppercase" data-qa="loanrepaymentsummary-span-tchpjr">
                  {{ $t("loanRepaymentSummary.additionalCharges") }}
                </span>
                <br data-qa="loanrepaymentsummary-br-u96oad"  />
                {{ config.payload.charges }}
              </v-flex>
              <v-flex xs6 sm6 md6 lg6 xl6 class="pt-2" data-qa="loanrepaymentsummary-flex-pa2cs">
                <span class="overline font-weight-bold text-uppercase" data-qa="loanrepaymentsummary-span-y0pbbi">
                  {{ $t("loanRepaymentSummary.remarks") }}
                </span>
                <br data-qa="loanrepaymentsummary-br-9d7o9g"  />
                {{ config.payload.transferNote }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-row>
        <v-row
          v-if="config.payload.charges"
          no-gutters
          class="px-8"
         data-qa="loanrepaymentsummary-row-jf01n">
          <v-alert
            icon="mdi-information-outline"
            class="v-alert--info"
           data-qa="loanrepaymentsummary-alert-eti0pk">
            <font class="body-2 font-weight-regular">
              {{ $t("loanRepaymentSummary.chargesInfo") }}
            </font>
          </v-alert>
        </v-row>
      </v-flex>
      <v-card-actions class="my-2 mt-10" data-qa="loanrepaymentsummary-card-actions-h8bbfg">
        <v-flex class="mx-6" xs5 sm2 md2 lg2 xl1 data-qa="loanrepaymentsummary-flex-v7jxul">
          <v-btn
              @click="goBack"
              outlined
              :color="primaryColor"
              class="body-1 text-capitalize font-weight-medium py-2 px-4"
             data-qa="loanrepaymentsummary-btn-k5lws5">
              {{ $t("common.back") }}
            </v-btn>
        </v-flex>
        <v-flex xs5 sm3 md3 lg3 xl2 data-qa="loanrepaymentsummary-flex-uxdkyl">
          <v-btn
            class="body-1 text-capitalize font-weight-medium white--text py-2 px-4"
            :color="primaryColor"
            @click="confirmLoanPayment"
           data-qa="loanrepaymentsummary-btn-hxc1a">
            {{ $t("common.confirm") }}
          </v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
    <!-- OTP Section -->
    <Modal
      v-if="enableOTP && showOTPScreen"
      :config="modalConfig.otp"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="loanrepaymentsummary-span-t2vhri">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <!-- Success/Failure -->
    <Modal
      v-if="showPaymentConfirmation"
      :config="modalConfig.paymentConfirm"
      @btn2Action="routeToloanDetails"
    >
    </Modal>
  </v-flex>
</template>

<script>
import moment from 'moment'
import event from '@/util/event'
import preload from '@/util/preload'
import commonService from '@/service/commonService.js'
import OtpInput from '@/components/common/OtpInput.vue'
import uuid from 'uuid-random'

export default {
  name: 'LoanRepaymentSummary',
  components: {
    OtpInput,
    Modal: () => import('@/components/common/Modal.vue')
  },
  props: {
    config: Object,
    display: Object
  },
  data () {
    return {
      showOTPScreen: false,
      showPaymentConfirmation: false,
      paymentCompleted: false,
      enableOTP: this.$appSettings.defaultConfigurations.enableOTPForLoanPayments,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      defaultCurrency: this.$appSettings.defaultConfigurations.currencyFormat.currency,
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        paymentConfirm: {
          enabled: true,
          persistent: true,
          subtitle: '',
          btn2Label: 'View Loan Details',
          width: 500
        }
      }
    }
  },
  created () {
    event.$on('IS_OTP_VALID', (valid) => {
      if (valid && this.enableOTP && this.showOTPScreen) {
        this.modalConfig.otp.enabled = true
        this.$store.dispatch('appStore/setAppData', {
          inProgress: true
        })
        this.onConfirm()
      } else {
        this.modalConfig.otp.enableSave = true
      }
    })
    event.$on('OTP_RESENT', (val) => {
      this.modalConfig.otp.enableSave = true
    })
  },
  methods: {
    getTickIcon () {
      return this.getSvgIconSrc('Tick')
    },
    goBack () {
      this.$emit('routeToLoanPayment', true)
    },
    async onConfirm () {
      // this.onOtpModalClose()
      const transactionReferenceID = uuid()
      const payloadData = {
        forcePostIndicator: false,
        postingEntries: [
          {
            accountId: this.config.payload.fromAcc,
            amount: {
              currency: this.config.payload.currency || this.defaultCurrency,
              amount: this.config.payload.transferAmount
            },
            creditDebitIndicator: 'DEBIT',
            narrative: this.config.payload.transferNote,
            postingType: this.$appSettings.defaultConfigurations.fundTransferDebitPostingType
          },
          {
            accountId: this.config.payload.toAcc,
            amount: {
              currency: this.config.payload.currency || this.defaultCurrency,
              amount: this.config.payload.transferAmount
            },
            creditDebitIndicator: 'CREDIT',
            narrative: this.config.payload.transferNote,
            postingType: this.$appSettings.defaultConfigurations.fundTransferCreditPostingType
          }
        ],
        sourceBranchCode: '00000001',
        sourceId: 'FFDC',
        transactionReference: transactionReferenceID,
        channelId: 'IBI',
        valueDate: moment().format()
      }
      const response = await commonService.postTransfer(payloadData)
      if (response.transactionReference) {
        this.modalConfig.paymentConfirm.subtitle = this.$t('loanRepaymentSummary.paymentSuccess')
        this.paymentCompleted = true
        this.showPaymentConfirmation = true
        this.modalConfig.paymentConfirm.enabled = true
        await preload.getListOfAccounts(
          JSON.parse(sessionStorage.getItem('username'))
        )
        event.$emit('isTransfer', this.paymentCompleted)
      } else {
        if (response && response.internalType === 'OTP-ERROR') {
          event.$emit('otp_validation_failed', response)
          return
        }
        this.onOtpModalClose()
        this.modalConfig.paymentConfirm.subtitle = this.$t('loanRepaymentSummary.paymentFailure')
        this.paymentCompleted = false
        this.showPaymentConfirmation = false
      }
      this.$store.dispatch('appStore/setAppData', {
        inProgress: false
      })
    },
    confirmLoanPayment () {
      if (this.enableOTP) {
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        this.onConfirm()
      }
    },
    onOtpModalClose () {
      this.showOTPScreen = false
      this.modalConfig.otp.enabled = false
    },
    routeToloanDetails () {
      this.showPaymentConfirmation = false
      event.$emit('showLoanDetails', true)
    }
  },
  watch: {
    showOTPScreen () {
      if (this.enableOTP && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID')
  }
}
</script>
